import script from "./withdrawPWCompletion.vue?vue&type=script&setup=true&lang=ts"
export * from "./withdrawPWCompletion.vue?vue&type=script&setup=true&lang=ts"

import "./withdrawPWCompletion.vue?vue&type=style&index=0&id=7a71e592&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a71e592"]])

export default __exports__